/** @format */

import React from 'react';
import '../css/Header.css';

import zbrush from '../images/technologies/zbrush.png';
import photoshop from '../images/technologies/photoshop.png';

import avatarTeacher from '../images/logo_dot.png';
import Tags from './buttons/Tags';
import dayjs from 'dayjs';
import Countdown from './Countdown';

import { useDispatch, useSelector } from 'react-redux';

import { openCounseling } from '../features/counseling';
import { openVideo } from '../features/video';

import BulletPointBlink from './buttons/BulletPointBlink';
import BulletPoint from './buttons/BulletPoint';

import Image from 'react-image-webp';

import image from '../images/3d-isolated.png';
// import imageWebp from '../images/3d-isolated.webp';
import backgroundRight from '../images/4.jpg';
import backgroundRightWebp from '../images/4.webp';

import backgroundLeftResize from '../images/3.jpg';
import backgroundLeftWebpResize from '../images/3.webp';
import underline from '../images/underline.png';

const countdown = 'Sat, 25 Jul 2022 16:00:00 GMT-5';

const benefits = [
  'Clases online en vivo.',
  'Material de ayuda.',
  'Grabaremos las clases.',
  'Acceso Discord.',
  'Certificado.',
  'Acceso 1 año.',
];

const Header = () => {
  const nowDay = dayjs();
  const openingDay = dayjs(countdown);

  const dispatch = useDispatch();

  const handleLink = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute('href');
    const location = document.querySelector(target).offsetTop;
    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  const banner = useSelector((state) => state.banner.value.banner);
  const width = window.innerWidth <= 460 ? 60 : 20;

  const paddingTop = banner
    ? { paddingTop: width + 90 }
    : { paddingTop: 80 };

  return (
    <section className='Header' id='home' style={paddingTop}>
            <div className='header-background'>
        <div className='left'>
          <Image
            src={backgroundLeftResize}
            webp={backgroundLeftWebpResize}
            alt='background'
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              position: 'relative',
              left: '-10%',
            }}
          />
        </div>
        <div className='right'>
          <Image
            src={backgroundRight}
            webp={backgroundRightWebp}
            alt='background'
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      </div>
      <div className='header-filter'></div>
      <div className='header-container container '>
        <div className='header-content padding'>
          <Image
            src={image}
            webp={image}
            alt='Máster en Blender'
            className='header-image'
          />
          <div className='header-item'>
            <BulletPoint color={'#77bf41'} />
            <p>Feedback en vivo</p>
          </div>
          <h1 className='header-title'>
            APRENDE ZBRUSH
            <br />
            <span>
              DESDE CERO
              <img
                src={underline}
                alt='underline'
                className='underline'
              />
            </span>
          </h1>
          <div className='master-benefits'>
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className='header-item'
                style={{ fontWeight: 'normal' }}>
                <BulletPoint color={'#6000de'} />
                <p>{benefit}</p>
              </div>
            ))}
          </div>
          <div className='header-buttons'>
            <button
              className='header-button see-trailer'
              onClick={() => {
                dispatch(
                  openVideo({
                    modal: true,
                    url: 'https://www.youtube.com/watch?v=BO4sQALaWn8',
                    type: 'common',
                  })
                );
              }}>
              VER TRAILER
            </button>

            <a
              href='#study'
              className='header-button see-payment'
              onClick={handleLink}>
              VER TEMÁTICA
            </a>
          </div>
          
        </div> 
        <div className='header-information'>
          <div className='header-information-content'>
            <img src={avatarTeacher} alt='Avatar Teacher' />
            <p className='teacher'>
              <span>Profesor: </span>Marcos García
            </p>
            <h2>
              Agenda tu
              <br />
              asesoría gratis
            </h2>
            <Tags name={'SOLICITA ASESORÍA'} />
            {openingDay.isAfter(nowDay) ? (
              <Countdown countdownTimestampMs={countdown} />
            ) : (
              <h3 className='start-master'>
                <BulletPointBlink color={'#77bf41'} />
                <span>Ya inició</span>
              </h3>
            )}
            <a
              href='#entrenamientos'
              className='payment'
              onClick={handleLink}>
              Inscríbete <span>&nbsp;Ahora&nbsp;</span>
            </a>
            <a
              href='#metodos-de-pago'
              className='to-payment-methods'
              onClick={handleLink}>
              MÉTODOS DE PAGO
            </a>
            <button
              className='payment-information'
              onClick={() => {
                dispatch(openCounseling());
              }}>
              * Pregunta por nuestros planes
              <br /> de financiación.
            </button>
          </div>
          <div className='header-information-technologies'>
            <img src={zbrush} alt='technology' style={{width: 34, height: 34, objectFit: 'contain'}} />
            <img src={photoshop} alt='technology' style={{width: 34, height: 34, objectFit: 'contain'}} />

          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
